// ======================================================================
// File Name       : CourseDialogConfirm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Modal, Col } from 'react-bootstrap';
import CoursePopupHeader from '../images/CoursePopupHeader.png';
import CoursePopupStep1 from '../images/CoursePopupStep1.png';
import CoursePopupStep2 from '../images/CoursePopupStep2.png';
import CoursePopupStep3 from '../images/CoursePopupStep3.png';
import CoursePopupStep4 from '../images/CoursePopupStep4.png';
import CoursePopupDetail from '../images/CoursePopupDetail.png';

class CourseDialogConfirm extends React.Component {

  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    return (
      <Modal
        className="modal-container modal-container-course-confirm"
        show={this.props.showModal}
        size={this.props.mdSize}
        animation={this.props.animation}
        style={style}
        dialogClassName={this.props.className}
      >
        <Modal.Header className="course-popup-header-confirm">
          <img src={CoursePopupHeader} alt="course popup header" loading="eager" />
        </Modal.Header>
        <Modal.Body className="text-center">
          <Col sm={12} md={6} lg={6}><img src={CoursePopupStep1} loading="eager" /></Col>
          <Col sm={12} md={6} lg={6}><img src={CoursePopupStep2} loading="eager" /></Col>
          <Col sm={12} md={6} lg={6}><img src={CoursePopupStep3} loading="eager" /></Col>
          <Col sm={12} md={6} lg={6}><img src={CoursePopupStep4} loading="eager" /></Col>
          <Col sm={12} className="course-popup-detail-confirm"><img src={CoursePopupDetail} loading="eager" /></Col>
        </Modal.Body>

        <Modal.Footer className="text-center">
          {this.props.onSelectOldLayout &&
            <Button variant="default" className=" margin-right-10 btn-96" onClick={this.props.onSelectOldLayout}>
              旧レイアウトを利用する
            </Button>
          }
          <Button variant="primary" className=" margin-left-10 btn-96" onClick={this.props.onSelectNewLayout}>
            新レイアウトを利用する
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

CourseDialogConfirm.defaultProps = { animation: true };
export default CourseDialogConfirm;
